/*
 * Browser-only fallback for dependencies that import node-fetch directly.
 * The explicit @solana/web3.js browser ESM build remains the preferred path.
 */
const nativeFetch = (...args) => globalThis.fetch(...args);
export default nativeFetch;
export const fetch = nativeFetch;
export const Headers = globalThis.Headers;
export const Request = globalThis.Request;
export const Response = globalThis.Response;
export const FormData = globalThis.FormData;
export const Blob = globalThis.Blob;
export const File = globalThis.File;
export class FetchError extends Error {
  constructor(message, type = 'system', systemError = undefined) {
    super(message);
    this.name = 'FetchError';
    this.type = type;
    this.code = systemError?.code;
    this.errno = systemError?.errno;
  }
}
